/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Sections_1_Paragraphs_1Inputs */

const en_gc_search_guides_what_is_gridcraft_sections_1_paragraphs_1 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_1_Paragraphs_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In a budget workbook, select a total to see whether it is a typed value or a formula. Then choose a nearby input cell, change one amount and watch the result. Undo the edit if you want to restore the sample. This connects the grid you see with the calculation behind it.`)
};

const zh_gc_search_guides_what_is_gridcraft_sections_1_paragraphs_1 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_1_Paragraphs_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在预算工作簿中，选中合计单元格，查看它是直接输入的数值还是公式。再选择附近的输入单元格，修改一项金额并观察结果。如果想恢复示例，可以撤销修改。这样能理解表格内容和计算逻辑之间的联系。`)
};

/**
* | output |
* | --- |
* | "In a budget workbook, select a total to see whether it is a typed value or a formula. Then choose a nearby input cell, change one amount and watch the result..." |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Sections_1_Paragraphs_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_sections_1_paragraphs_1 = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Sections_1_Paragraphs_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Sections_1_Paragraphs_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_sections_1_paragraphs_1(inputs)
	return zh_gc_search_guides_what_is_gridcraft_sections_1_paragraphs_1(inputs)
});
export { gc_search_guides_what_is_gridcraft_sections_1_paragraphs_1 as "gc.search_guides.what_is_gridcraft.sections.1.paragraphs.1" }